import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import api from '@/lib/api';

// Admin-only evidence download. A 10-minute link is fetched first so a normal tap works on phones/tablets too.
export default function SecureExportDownload() {
  const { batch } = useParams();
  const [state, setState] = useState('loading');
  const [href, setHref] = useState('');

  const prepare = async () => {
    setState('loading');
    try {
      const { data } = await api.post(`/admin/secure-exports/${batch}/link`);
      setHref(`${process.env.REACT_APP_BACKEND_URL}${data.url}`);
      setState('ready');
    } catch (e) {
      setState(e?.response?.status === 403 ? 'denied' : 'missing');
    }
  };

  useEffect(() => { prepare(); }, [batch]); // eslint-disable-line react-hooks/exhaustive-deps

  const msg = { loading: 'Preparing your download…', ready: 'Tap the button below. The link works for 10 minutes.',
    denied: 'Only company admins can download this file.', missing: 'This file is not available.' }[state];
  return (
    <div className="p-10 max-w-lg space-y-4" data-testid="secure-export-download">
      <h1 className="text-xl font-semibold break-all">{batch}.zip</h1>
      <p className="text-sm text-muted-foreground" data-testid="secure-export-status">{msg}</p>
      {state === 'ready' && (
        <a href={href} download={`${batch}.zip`} data-testid="secure-export-download-link"
          className="inline-flex items-center justify-center rounded-md bg-primary text-primary-foreground px-6 py-3 text-base font-medium hover:opacity-90 transition-opacity">
          Download file
        </a>
      )}
      {(state === 'missing' || state === 'ready') && (
        <div><Button variant="outline" onClick={prepare} data-testid="secure-export-refresh">Make a new link</Button></div>
      )}
    </div>
  );
}
